module.exports = __webpack_public_path__ + "img/exception.ee0f1d7b.svg";